import type { ColumnsType } from 'antd/es/table';

import { ReceiptDocumentListItemSchema } from '@app/models/wms';
import { formatDate } from '@app/services/date';
import { TableCellEllipsisText } from '@components/TableCellEllipsisText';

import { MappedStatusTag } from './components/MappedStatusTag';
import { RetrieveDocumentListItemSchema } from './interfaces';

export const SHARED_COLUMNS: ColumnsType<RetrieveDocumentListItemSchema> = [
  {
    dataIndex: 'number',
    key: 'number',
    width: 180,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value || '—'} />,
  },
  {
    dataIndex: 'dt_document',
    key: 'dt_document',
    width: 140,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value ? formatDate(value) : '—'} />,
  },
  {
    dataIndex: 'mapped_status',
    key: 'mapped_status',
    width: 140,
    render: (_: unknown, record) => (
      <MappedStatusTag status={record.mapped_status} rawStatus={record.raw_status} />
    ),
  },
  {
    dataIndex: 'sender',
    key: 'sender',
    width: 200,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value || '—'} />,
  },
  {
    dataIndex: 'recipient',
    key: 'recipient',
    width: 200,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value || '—'} />,
  },
  {
    dataIndex: 'weight',
    key: 'weight',
    width: 110,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value ?? '—'} />,
  },
  {
    dataIndex: 'volume',
    key: 'volume',
    width: 110,
    ellipsis: true,
    render: (value: string | null) => <TableCellEllipsisText value={value ?? '—'} />,
  },
];

export const SHIPMENT_COLUMNS: ColumnsType<RetrieveDocumentListItemSchema> = [];

export const RECEIPT_COLUMNS: ColumnsType<RetrieveDocumentListItemSchema> = [
  {
    dataIndex: 'purchase_order_number',
    key: 'purchase_order_number',
    width: 220,
    ellipsis: true,
    render: (_: unknown, record) => (
      <TableCellEllipsisText value={(record as ReceiptDocumentListItemSchema).purchase_order_number || '—'} />
    ),
  },
];
